import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function EstatePlanningPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas['estate-planning']} />;
}
